import { ApiType } from '@portals/shared/portal/ApiDto';

/**
 * Alternative more user-friendly name than saying integration service.
 * @param type
 */
export function apiOrEvent(type: ApiType) {
  switch (type) {
    case ApiType.REST: {
      return 'API';
    }
    case ApiType.EVENT: {
      return 'event';
    }
    case ApiType.MCP: {
      return 'MCP server';
    }
  }
}
